const DASHBOARD_ROUTE_NAMES = ['Dashboard', 'DefaultDashboard'];
const RESTORE_POLL_MS = 250;
const RESTORE_MAX_ATTEMPTS = 12;

let pending = null;
let poll = null;

const getScrollContainer = () =>
    document.querySelector('.sub-route-layout__leading') || document.querySelector('.pendo-page-container');

// Called when a widget link leaves a dashboard; only a Back to that dashboard restores the position.
export function rememberDashboardScroll (route) {
    pending = { fullPath: route.fullPath, top: getScrollContainer()?.scrollTop };
}

export function restoreDashboardScroll (to, savedPosition) {
    clearInterval(poll);
    if (!DASHBOARD_ROUTE_NAMES.includes(to.name)) return;
    const { fullPath, top } = pending || {};
    pending = null;
    if (!savedPosition || !top || fullPath !== to.fullPath || to.query.widgetId) return;
    // The scroll container persists across routes, so clear leftover scroll before treating any scroll as the user's.
    getScrollContainer()?.scrollTo({ top: 0, behavior: 'instant' });
    let attempts = 0;
    // Muuri lays out in web workers, so the page only reaches full height some time after mount.
    poll = setInterval(() => {
        attempts += 1;
        const container = getScrollContainer();
        // 1px slack: scrollTop can be fractional under display scaling while scrollHeight is rounded.
        const isTallEnough = container && container.scrollHeight - container.clientHeight >= top - 1;
        // A non-zero scrollTop means the user already scrolled.
        const hasScrolled = container?.scrollTop;
        if (isTallEnough && !hasScrolled) {
            container.scrollTo({ top, behavior: 'instant' });
        }
        if (isTallEnough || hasScrolled || attempts >= RESTORE_MAX_ATTEMPTS) {
            clearInterval(poll);
        }
    }, RESTORE_POLL_MS);
}
